export default __webpack_public_path__ + "static/hepatitis-a-a335c54f79bd20f904bc05900528ea53.png";